import React from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import DemoLayoutComponent from '../../Components/Layout/DemoLayoutComponent';

function DemoLayout(props) {    
    let navigate = useNavigate();
    const params = useParams();    
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const name = queryParams.get('name');


    return (
        <div>
            <DemoLayoutComponent {...props} navigate={navigate} id={params.id} name={name} />
        </div>
    );

}

export default DemoLayout